import { getCategoryHref } from '../../utils/common/category';
import { BLOG_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'blogTitleGeneratorType',
      analyticsName: 'blog_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: BLOG_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Blog',
        value: getCategoryHref(BLOG_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'blogTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'blog_titles_generator',
      placeholder: 'Try "online ad basics" or "keto diet for beginners"',
      textLabel: 'Describe the blog topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: BLOG_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
